import gql from "graphql-tag"

export const UPDATE_MEANS_OF_VERIFICATION = gql`
  mutation updateManyMeansOfVerification(
    $id: ID!
    $relationType: TypeEnum!
    $data: [UpdateMeansOfVerificationInput!]!
  ) {
    updateManyMeansOfVerification (
      data: $data
      id: $id
      relationType: { type: $relationType }
    ) {
      id
      verificationDocumentsPerMonth {
        id
      }
      activity {
        id
      }
      indicator {
        id
      }
    }
  }
`
